import { render, staticRenderFns } from "./Modal.vue?vue&type=template&id=8c907708&scoped=true&"
var script = {}
import style0 from "./Modal.vue?vue&type=style&index=0&id=8c907708&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c907708",
  null
  
)

export default component.exports